import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePageGoogleAirDuct.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
import AllServicesData from '../ServicesPage/AreaData'
// images
import LocationReviewsData from './LocationReviewsData'
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';

export default function HomePageGoogleAirDuct({ locationsMain, CitiePhone, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    const [response, setResponse] = useState({});
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const url = new URL(window.location.href);

    const fireSmithCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "smith_air_duct_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    const data = {
        title: "",
        rows: [

            {
                title: "Why choose Smith & Sons Air Duct?",
                content: "With 50 years of expertise, we provide professional, reliable air duct services, ensuring safety and efficiency in every home."
            },
            {
                title: "What services do you offer?",
                content: "We offer air duct cleaning, air duct inspection, air duct repair and sealing, HVAC and furnace cleaning, vent cleaning, and air duct sanitizing — plus chimney sweep services on request."
            },
            {
                title: "How much is a air duct inspection?",
                content: "Our air duct inspection costs $69. It includes a comprehensive check to identify potential issues."
            },
            {
                title: "Can you clean and repair together?",
                content: "Yes, we offer same-day cleaning and repair services during your appointment if needed."
            },
            {
                title: `Do you provide services surrounding ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}?`,
                content: `Yes, we don't just serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}! We cover a wide area, including a 75-mile radius around ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Whether you're in nearby towns or surrounding areas, we're here to help.`
            },
            {
                title: "How do I book an appointment?",
                content: `Call us <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out the <a href='/book${location.search ? location.search + '&' : '?'}service=airduct'>online form</a> to schedule your visit.`
            },

        ]
    };
    const styles = {
        bgColor: 'white',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#082d49',
        rowTitleTextSize: '21px',
        rowContentColor: '#082d49',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#082d49",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Smith & Sons air duct cleaning" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Smith & Sons chimmney sweep from title)(if no keywords just do for air duct cleaning) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);

    return (
        <div className="HomePageGoogleAirDuct" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Smith & Sons Air Duct | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.smithandsonsair duct.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Air Duct Cleaning provides top-quality air duct cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your air duct service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Air Duct Cleaning provides top-quality air duct cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your air duct service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Air Duct Cleaning" data-react-helmet="true" />
                <meta name="keywords" content="air duct cleaning, air duct Inspection, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, air duct services, air duct service, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct Insulation, Air Duct Installation, Air Duct Liner Repair, Air Duct Pointing, Air Duct Rainp Installation, Air Duct Repair, Air Duct Crown Repair, Air Duct Restoration, Air Duct Flue Installation, Air Duct Flue Repair, ​Air Duct Construction, Air Duct Vent Installation, Air Duct Flashing, Flexible Air Duct Liner Installation, Air Duct Damper Repair, Air Ductp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>PREMIUM AIR DUCT SERVICE IN {CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "YOUR AREA"} IS OUR SUPERPOWER</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Air Duct Inspections, Repair And Cleaning Near Me</h2>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                        <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Cleaning Near Me Smith and Sons" /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 4.9 on Google</h3>
                        <span>
                            <h4>4.9</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerRight">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Banner6LogoDuct.png`)} />
                </div>
            </div>
            {/* MainBanner2Top2 */}

            <div className="MainBanner2Top2" id="about">
                <div className="MainBanner2Top2Bottom">
                    <a>No extra charge for appointments on nights, weekends or holidays</a>
                </div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <h3>AIR DUCT CLEANING</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <h3>AIR DUCT INSPECTION</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneymaintenance.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <h3>AIR DUCT MAINTENANCE</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Air Duct Cleaning" />
                        </div>
                        <h3>AIR DUCT REPAIR</h3>
                    </a>
                </div>

                <div className="MainBanner2TopBoxMainChat">
                    <img src={require(`../../ImagesLogos/Banner3Logo.png`)} />
                    <div className="MainBanner2TopBoxMainChatText">
                        <h4>{response.title}</h4>
                        <h3>{response.body}</h3>
                        <h5>Call us at <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a> or fill out the <a href={`/book${location.search ? location.search + '&' : '?'}service=airduct`}>online form</a> to schedule your visit.</h5>
                    </div>
                </div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/dryer", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} Landing →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            {/* HomePageGoogleAirDuctBen */}
            <div className="HomePageGoogleAirDuctBen">
                <div className="HomePageGoogleAirDuctBenLEFT">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Image2Logo.png`)} />
                </div>
                <div className="HomePageGoogleAirDuctBenRIGHT">
                    <h1>SUPER BENEFITS</h1>
                    <div className="HomePageGoogleAirDuctBenRIGHTList">
                        <div className="HomePageGoogleAirDuctBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Air Duct technicians completed more than 6,500 hours of training in 2022</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleAirDuctBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleAirDuctBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 6,000+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleAirDuctBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleAirDuctBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleAirDuctUs */}
            <div className="HomePageGoogleAirDuctUs">
                <div className="HomePageGoogleAirDuctUsLeft">
                    <h1>KEEPING YOUR AIR DUCT SAFE</h1>
                    <h2>
                        When you’ve got a air duct issue, there’s only one name to call — Smith & Sons Air Duct. And it’s not just because of our decades of experience, our stellar reviews, or even our industry awards. It’s because everything we do; we do with your safety and comfort in mind.
                    </h2>
                    <div className="HomePageGoogleAirDuctUsLeftMoreBox">
                        <h3>HERITAGE</h3>
                        <h4>Proudly serving communities since 2001, built on decades of trusted air duct expertise.</h4>
                    </div>
                    <div className="HomePageGoogleAirDuctUsLeftMoreBox">
                        <h3>RESPONSIVENESS</h3>
                        <h4>Always ready when you need us—rapid service, including same-day and emergency visits, year-round.</h4>
                    </div>
                    <div className="HomePageGoogleAirDuctUsLeftMoreBox">
                        <h3>EXCELLENCE</h3>
                        <h4>Comprehensive air duct services delivered with cutting-edge tools and meticulous attention to detail.</h4>
                    </div>
                    <h6>The team that keeps your family safe and warm with every call.</h6>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                        <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Cleaning Near Me Smith & Sons Air Duct" /></a>
                    </div>
                </div>
                <div className="HomePageGoogRight">
                    <img fetchpriority="low" src={require(`../../Images/airduct1beforeandafter.png`)} />
                    <img fetchpriority="low" src={require(`../../Images/airduct2.png`)} />
                </div>
            </div>
            {/* MainBannerMore */}
            <div className="MainBannerMore">
                <diiv className="MainBannerMoreLeft">
                    <h1>Your Trusted Experts for All Your Air Duct Needs!</h1>
                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>CALL NOW TO SCHEDULE</a>
                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                </diiv>
                <img fetchpriority="low" src={require(`../../ImagesLogos/Banner5LogoDuct.png`)} />

            </div>
            {/* HomePageGoogleAirDuctReviews */}
            <div className="HomePageGoogleAirDuctReviews" id='reviews'>
                <h1>Real Testimonials from Our Valued Client in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}</h1>
                <div className="LocationReviewsLsit">
                    <div className="LocationReviewsLsitUnder">
                        {LocationReviewsData.slice(0, 36).map((A, index) =>
                            <div key={index} className="LocationReviewsBox">
                                <div className="LocationReviewsBoxLeft">
                                    {/* <h3>Open Now 24/7 • Top Rated • Same Day Service</h3> */}
                                    <span>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/checklist.png`)}></img>
                                    </span>
                                    <h2><img src={require(`../../Images/GoogleIcons.png`)}></img>Rated 5 By {A.customer_name}</h2>
                                    <h4>{A.review}</h4>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="LocationReviewsLsitShodowR"></div>
                </div>
            </div>
            {/* HomePageGoogleAirDuctCar */}
            <div className="HomePageGoogleAirDuctCar">
                <div className="HomePageGoogleAirDuctCarMain">
                    <div className="HomePageGoogleAirDuctCarLeft">
                        <img fetchpriority="low" src={require(`../../ImagesLogos/Banner4LogoDuct.png`)} />
                    </div>
                    <div className="HomePageGoogleAirDuctCarRight">
                        <h1>AIR DUCT SWEEP & FIREPLACE EXPERT <br /> IN {CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "YOUR AREA"}</h1>
                        <h2>Call For Service:</h2>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                            <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Cleaning Near Me Smith and Sons" /></a>
                        </div>
                    </div>
                </div>
                <div className="HomePageGoogleAirDuctCarBottom">
                    <a>No extra charge for appointments on nights, weekends or holidays</a>
                </div>
            </div>
            {/* BookAnAppointment */}
            <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            {/* HomePageGoogleAirDuctService */}
            <div className="HomePageGoogleAirDuctService" id="ourservices">
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>AIR DUCT CLEANING</h2>
                            <h3>
                                Your Trusted Partner for Air Duct Cleaning in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}
                                <br />
                                <br />
                                Over time, dust, pet dander, pollen, and allergens build up deep inside your ductwork and recirculate through every room. At Smith & Sons Air Duct, our technicians use powerful negative-air vacuums and rotating brushes to scrub every supply and return line clean. The result is fresher indoor air, less dust on your furniture, and an HVAC system that breathes easy and runs more efficiently.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning Smith and Sons" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">

                        <div className="MainBanner2BottomBoxLeft">
                            <h2>AIR DUCT INSPECTION</h2>
                            <h3>
                                Thorough Air Duct Inspections for Peace of Mind
                                <br />
                                <br />
                                Not sure if your ducts need cleaning? Our $69 air duct inspection uses in-duct cameras to show you exactly what's hiding in your system — dust packs, debris, mold growth, or leaks robbing your home of airflow. We walk you through the findings on the spot, with honest, upfront pricing and no pressure, so you only pay for the service your home actually needs.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airduct2.png`)} alt="Air Duct Inspection Smith and Sons" />
                        </div>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>AIR DUCT REPAIR & SEALING</h2>
                            <h3>
                                Reliable Air Duct Repair & Sealing Solutions
                                <br />
                                <br />
                                Leaky, disconnected, or crushed ducts force your system to work harder while letting conditioned air escape into your attic and walls. At Smith & Sons Air Duct, we repair and reseal damaged ductwork, replace worn flex lines, and seal every joint so your heating and cooling reaches every room. The payoff is a more comfortable home and lower energy bills month after month.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airductrepair.png`)} alt="Air Duct Repair Smith and Sons" />

                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>HVAC & FURNACE CLEANING</h2>
                            <h3>
                                Complete HVAC & Furnace Cleaning
                                <br />
                                <br />
                                Your air ducts are only as clean as the system feeding them. Smith & Sons Air Duct cleans the heart of your HVAC — blower compartments, evaporator coils, and furnace components — to clear out the dust and grime that strain your equipment. A clean furnace and coil mean stronger airflow, fewer breakdowns, and a system that heats and cools the way it was built to.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airduct3.png`)} alt="HVAC and Furnace Cleaning Smith and Sons" />

                        </div>
                    </div>

                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>AIR DUCT SANITIZING & DISINFECTION</h2>
                            <h3>
                                Air Duct Sanitizing & Disinfection
                                <br />
                                <br />
                                Dark, humid ductwork is the perfect place for mold, mildew, bacteria, and musty odors to take hold. After a deep clean, Smith & Sons Air Duct applies EPA-registered, pet- and family-safe sanitizers that fog through your entire system to kill what's left behind. You'll notice fresher-smelling air and real peace of mind — ideal for allergy sufferers and anyone who wants a healthier home.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airductbrush.png`)} alt="Air Duct Sanitizing and Disinfection Smith and Sons" />

                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>DRYER VENT CLEANING</h2>
                            <h3>
                                Dryer Vent Cleaning for a Safer Home
                                <br />
                                <br />
                                A lint-clogged dryer vent is one of the leading causes of house fires — and it makes your dryer work harder, run longer, and wear out faster. Smith & Sons clears every inch of your dryer ductwork, from the lint trap to the exterior vent, so your clothes dry in a single cycle and your home stays safe. Ask us to add dryer vent cleaning to your air duct visit.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryercleaning.png`)} alt="Dryer Vent Cleaning Smith and Sons" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY SWEEP & FIREPLACE</h2>
                            <h3>
                                Chimney Sweep & Fireplace Services Too
                                <br />
                                <br />
                                While we're caring for your home's air, Smith & Sons also handles your chimney and fireplace. Our certified sweeps remove dangerous soot and creosote buildup, inspect for blockages and damage, and keep your fireplace burning safely all season long. One trusted local team for cleaner air ducts and a safer chimney — book both in a single visit and save.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ChimneyIM8.jpg`)} alt="Chimney Sweep Smith and Sons" />

                        </div>


                    </div>
                </div>
            </div>
            {/* locationsMain */}
            {locationsMain.find(a => a.Phone == CitiePhone) ?
                <div className="HomePageGoogleAirDuctLocation">
                    <div className="HomePageGoogleAirDuctLocationLeft">
                        <h1>WHERE YOU'LL FIND SMITH & SONS AIR DUCT</h1>
                        <h2>Smith & Sons Air Duct proudly serves families, offering expert air duct services. Our skilled technicians are just a short phone call away, ready to assist in neighborhoods throughout <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b>, and the surrounding areas.</h2>
                        {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                            <div key={index} className="HomePageGoogleAirDuctLocationLeftBox">
                                <h4>{A.Location1}</h4>
                                <h5>{A.Address1}</h5>
                                <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                            </div>
                        )}
                    </div>
                    <div className="HomePageGoogleAirDuctLocationRight">
                        <div className="HomePageGoogleAirDuctLocationRightMap">

                            <div className="HomePageGoogleAirDuctLocationRightBorder"></div>
                            <iframe src={locationsMain.find(a => a.Phone == CitiePhone).Map} ></iframe>
                        </div>
                        <div className="HomePageGoogleAirDuctLocationRightBox">
                            <h4>Smith & Sons Air Duct is proud to provide expert air duct cleaning, inspection, and repair services to the {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} area.</h4>
                            <div className="HomePageGoogleAirDuctLocationRightBoxMenu">
                                <span>
                                    <h2>Manager:</h2>
                                    <h3>Mike Oliver</h3>
                                </span>
                                <span>
                                    <h2>Phone Number:</h2>
                                    <h3>{CitiePhone ? CitiePhone : "866-907-7220"}</h3>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                : null}
            {/* HomePageGoogleAirDuctFAQ */}
            <div className="HomePageGoogleAirDuctFAQ">
                <h2>GOT QUESTIONS? WE'VE GOT ANSWERS.</h2>
                <h3>Feel Free To Reach Out To Us By Phone. For The Fastest Response, We Are Available By Phone 24/7 And Ready To Provide You With A Complimentary Consultation.</h3>
                <div className="MainBannerLeftButtons">
                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                    <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Cleaning Near Me Smith and Sons" /></a>
                </div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
            {/* HomePageGoogleAirDuctFooter */}
            <div className="HomePageGoogleAirDuctFooter" id='footer'>
                <div className="HomePageGoogleAirDuctFooterTop">
                    <div className="HomePageGoogleAirDuctFooterTopTitle">
                        <h1>RELIABLE SERVICE, TRUSTED RESULTS</h1>
                        <h2>BOOK YOUR APPOINTMENT NOW!</h2>
                        <h3>With our highly-skilled technicians & upfront pricing, you can trust the local {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"} experts at Smith & Sons Air Duct for 100% satisfaction, guaranteed on all air duct cleaning services.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a onClick={() => navigate(`/book${location.search ? location.search + '&' : '?'}service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Cleaning Near Me Smith and Sons" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleAirDuctFooterTopImg">
                        <img src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                    </div>
                </div>
                <div className="HomePageGoogleAirDuctFooterBottom">
                    <div className="HomePageGoogleAirDuctFooterBottomTop">
                        <img src={require(`../../ImagesLogos/Banner2Logo.png`)} />
                        <p>Copyright © 2024 - Smith & Sons Air Duct. All Rights Reserved. Privacy Policy</p>
                        <div className="SiteMapDiv">
                            <h1>Privacy</h1>
                            <a href="/privacy-policy">Privacy Policy</a>
                            <a href="/terms-and-conditions">Terms And Conditions</a>
                        </div>
                    </div>
                    {locationsMain.find(a => a.Phone == CitiePhone) ?
                        <div className="HomePageGoogleAirDuctFooterMiddle">
                            <h1>OFFICE LOCATIONS</h1>
                            {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageGoogleAirDuctLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`} onClick={fireSmithCall}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        : null}
                    <div className="HomePageGoogleAirDuctFooterBottomTop">
                        <h1>CONNECT WITH US</h1>
                        <p>Phone: {CitiePhone}</p>
                        <p>info@smithandsonsair duct.com</p>
                        <p>www.smithandsonsair duct.com</p>
                    </div>



                </div>
            </div>
        </div>
    )
}

